<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Плитка категорий</h1>
          <va-button
            color="info"
            @click="openCreateModal"
          >
            Добавить плитку
          </va-button>
        </div>
      </va-card>

      <category-tiles-table
        class="mb-4"
        :tiles="getCategoryTiles"
      />

      <va-modal
        v-model="showCreateForm"
        size="large"
        hide-default-actions
      >
        <category-tile-create @action="hideModal" />
      </va-modal>
    </va-inner-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CategoryTilesTable from '@/components/category-tiles/category-tiles-table.vue'
import CategoryTileCreate from '@/components/category-tiles/category-tile-create.vue'

export default {
  name: 'MainPage',
  components: { CategoryTilesTable, CategoryTileCreate },
  data() {
    return {
      showCreateForm: false,
    }
  },
  async created() {
    try {
      await this.fetchCategoryTiles()
    } catch (error) {
      console.error('Error in MainPage created:', error)
    }
  },
  computed: {
    ...mapState('categoryTiles', ['category_tiles']),
    ...mapGetters({
      loader: 'isLoading',
    }),
    getCategoryTiles() {
      return this.category_tiles
    },
  },
  methods: {
    ...mapActions({
      fetchCategoryTiles: 'categoryTiles/getCategoryTiles',
    }),
    hideModal(val) {
      if (val) {
        this.showCreateForm = false
      } else {
        this.showCreateForm = false
      }
    },
    openCreateModal() {
      this.showCreateForm = !this.showCreateForm
    },
  },
}
</script>

<style scoped>
</style>

